<script>
import axios from "axios";

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
let user = JSON.parse(localStorage.getItem("user"));

/**
 * Register component
 */
export default {
  page: {
    title: "gửi đường tàu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Sửa dịch vụ gửi đường tàu",
      items: [
        {
          text: "Trang Chủ",
          href: "/",
        },
          {
          text: "Dịch vụ",
          href: "/danh-sach-dich-vu",
        },
        {
          text: "Sửa dịch vụ gửi đường tàu",
          active: true,
        },
      ],

      service: {
        name: "Gửi hàng us-us",
        type: 1,
        seaway: {
          price: 1.99,
          lb_min: 10,
          disc: 0, // discount
          disc_unit: "%",
          disc_option: ["%", "%"],
        },
      },
      submitted: false,
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    // Try to register the service in with the email, name
    // and password they provided.

    tryingToUpdate() {
      this.submitted = true;
      axios({
        url: process.env.VUE_APP_SERVER_URL + "/service/update",
        method: "post",
        headers: {
          authorization: user.token,
        },

        data: this.service,
      })
        .then(({ data }) => {
          this.$toasted.success("Sửa dịch vụ thành công");
        })
        .catch((error) => {
          this.$toasted.error("Sửa dịch vụ có lỗi");
        });
    },
  },

  created() {
    if (!this.$route.query.id) {
      this.$router.push("/");
    }
    let _id = this.$route.query.id;

    axios({
      url: process.env.VUE_APP_SERVER_URL + "/service/info",
      method: "post",
      headers: {
        authorization: user.token,
      },

      data: {
        _id: _id,
      },
    })
      .then(({ data }) => {
        if (data) {
          this.service = Object.assign({}, this.service, data);
        } else {
          this.$toasted.error("Không tìm thấy dịch vụ phù hợp");
          this.$router.push("/");
        }
      })
      .catch((err) => {
        this.$toasted.error("Không tìm thấy dịch vụ phù hợp");
        // this.$router.push("/");
      });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :items="items" />
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="card overflow-hidden">
          <div class="card-body pt-0">
            <b-form class="my-2 p-2" @submit.prevent="">
              <b-form-group
                class="mb-3"
                id="service-name"
                label="Tên dịch vụ"
                label-for="name"
              >
                <b-form-input
                  v-model="service.name"
                  type="text"
                  placeholder="Nhập tên"
                ></b-form-input>
              </b-form-group>
              <div class="px-3">
                <b-row>
                  <b-col class="md-3">
                    <b-form-group
                      class="mb-3"
                      :label="'Giá dịch vụ'"
                      label-for="provide"
                    >
                      <b-form-input
                        v-model="service.seaway.price"
                        type="number"
                        step="0.01"
                        min="0.00"
                        max="1000000.00"
                        placeholder="Giá dịch vụ"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <span>Lb tối thiểu </span>
                      <div class="py-2">
                        <b-form-input
                          v-model="service.seaway.lb_min"
                          debounce="500"
                          type="number"
                          step="0.01"
                          min="0.00"
                          max="1000000.00"
                          placeholder="Nhập dữ liệu"
                        ></b-form-input>
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <span>Giảm giá </span>
                      <div class="py-2">
                        <b-form-input
                          v-model="service.seaway.disc"
                          step="0.01"
                          min="0.00"
                          max="1000000.00"
                          type="number"
                          placeholder="Thuế cho loại sản phẩm"
                        ></b-form-input>
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group>
                      <span>Đơn vị giảm giá</span>
                      <div class="py-2">
                        <b-form-select
                          class="form-control"
                          v-model="service.seaway.disc_unit"
                          size="md"
                          :options="['$', '%']"
                        ></b-form-select>
                      </div>
                    </b-form-group>
                  </b-col>
                     <b-col>
                    <b-form-group>
                      <span>% nhân viên</span>
                      <div class="py-2">
                        <b-form-input
                          v-model="service.seaway.salary"
                          debounce="500"
                          type="number"
                          step="0.01"
                          min="0.00"
                          max="1000000.00"
                          placeholder="Nhập dữ liệu"
                        ></b-form-input>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div class="mt-4 d-grid">
                <b-button
                  type="submit"
                  variant="primary"
                  @click="tryingToUpdate"
                  class="btn-block"
                  >Sửa dịch vụ</b-button
                >
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>